export const dashboardData = {
  intro:
    "Think of this as a quick, low-stakes workout for your professional skills. We’ll tailor real-world practice tasks to the role and tools you use daily.",
  subtitle: "Ready to practise?",
  buttonText: "Personalise your path",
  prompt: "You’ll be asked 4 quick questions to tailor your experience",
  steps: ["Your role", "Your tools", "Guidance level", "Pick a task"],
};
